/* 孫吳傳・第 16 章：濡須（213 年）
 * 北邊是曹操的大營，木柵圍成一圈，南面兩處營門用鹿角擋著；南邊是吳軍的濡須塢。夜裡，視野很短。 */
export const CAMP = { x: 3500, y: 1500, hw: 1100, hh: 600 };
const T = 30, N = CAMP.y - CAMP.hh, S = CAMP.y + CAMP.hh, Wx = CAMP.x - CAMP.hw, E = CAMP.x + CAMP.hw;
export const DOORS = [[3000, S], [4000, S]], WU = [3500, 4500];
export default {
  id: 'ruxu', name: '濡須', W: 7000, H: 5200, seed: 213,
  bases: [WU, [3500, 1300]],
  walls: [
    [CAMP.x, N, CAMP.hw + T, T], [Wx, CAMP.y, T, CAMP.hh], [E, CAMP.y, T, CAMP.hh],
    [(Wx + DOORS[0][0] - 120) / 2, S, (DOORS[0][0] - 120 - Wx) / 2, T], [(DOORS[0][0] + DOORS[1][0]) / 2, S, (DOORS[1][0] - DOORS[0][0] - 240) / 2, T], [(DOORS[1][0] + 120 + E) / 2, S, (E - DOORS[1][0] - 120) / 2, T],
  ],
  roads: [{ pts: [WU, [3500, 3300], [3000, 2400], DOORS[0]], w: 120 }, { pts: [[3500, 3300], [4000, 2400], DOORS[1]], w: 120 }],
  rocks: [[1500, 3000, 420, 220], [5600, 3100, 420, 220], [1200, 1200, 300, 160], [6000, 1300, 300, 160]],
  woods: 0.45,
  sight: 0.55,
  clearings: [[CAMP.x, CAMP.y, 1200], [WU[0], WU[1], 500], [3500, 2700, 500]],
  tents: [{ x: CAMP.x, y: CAMP.y - 50, n: 16, r: 820, chief: true, col: '#3b5a99', flag: '曹' }, { x: WU[0], y: WU[1], n: 6, r: 380, col: '#b8433a', flag: '甘' }],
  grass: [[2700, 2700, 240, 110], [4300, 2700, 240, 110], [3500, 3300, 220, 100]],
};
